import ApplicationRecord from "./ApplicationRecord";
import ImageRecord from "./ImageRecord";

export default class Link extends ApplicationRecord({
  ID: 1,
  /**
   * Card title
   * @type {String}
   */
  title: "",
  /**
   * Button title
   * @type {String}
   */
  button: "",
  /**
   * HTML text for exerpt
   * @type {String}
   */
  exerpt: "",
  /**
   * Button target attribute
   * @type {String}
   */
  target: "_blank",
  /**
   * Button destination.
   * @type {String}
   */
  href: "",
  /**
   * If card should be in full width
   * @type {String}
   */
  IsFull: "",
}) {
  /**
   * If this link card should be full width.
   * @return {Boolean}
   */
  isFull() {
    return this.IsFull === 1;
  }
  /**
   * @return {ImageRecord} Image cropped in a portrait ratio
   */
  imagePortrait() {
    return this._getOne("ExcerptImgPortrait", ImageRecord);
  }
  /**
   * @return {ImageRecord} Image cropped in a landscape ratio
   */
  imageLandscape() {
    return this._getOne("ExcerptImgLandscape", ImageRecord);
  }
}



// WEBPACK FOOTER //
// ./src/models/Link.js